import {Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faChevronLeft} from '@fortawesome/free-solid-svg-icons'

export default function ChangeDevice (props) {
  return props?.changeDevice ? 
      <Link className="change-site" onClick={() => props.changeDevice()} to="#">
        <FontAwesomeIcon icon={faChevronLeft}/>&nbsp;Change Device
      </Link>
    : null
}
